import SharedVideo from "@/components/shared/VideoConference";
export default function ConsultantVideo() {
  return <SharedVideo role="consultant" />;
}